export default {
  pdfPageNavigator: {
    pagina: 'Pagina',
    de: 'de'
  }
};
